import { Permission, rolePermissions } from 'src/assets/data/permissions';

export type PermissionOption = {
  id: Permission;
  category: string;
};

export const PERMISSIONS: PermissionOption[] = [
  // Client permissions
  { id: Permission.CreateClient, category: 'Client' },
  { id: Permission.ReadClient, category: 'Client' },
  { id: Permission.UpdateClient, category: 'Client' },
  { id: Permission.DeleteClient, category: 'Client' },
  { id: Permission.CanImpersonate, category: 'Client' },
  // Service-line level: manages scheduled pauses (activation/deactivation windows)
  { id: Permission.ScheduledPauseManage, category: 'Client' },

  // User management
  { id: Permission.CreateUser, category: 'User Management' },
  { id: Permission.ReadUser, category: 'User Management' },
  { id: Permission.UpdateUser, category: 'User Management' },
  { id: Permission.DeleteUser, category: 'User Management' },

  // Customer management
  { id: Permission.CreateCustomer, category: 'Customer' },
  { id: Permission.ReadCustomer, category: 'Customer' },
  { id: Permission.UpdateCustomer, category: 'Customer' },
  { id: Permission.DeleteCustomer, category: 'Customer' },

  // Invoices
  {
    id: Permission.CreateCreditInvoice,
    category: 'Invoices',
  },
  {
    id: Permission.CreateDebitInvoice,
    category: 'Invoices',
  },
  { id: Permission.ReadInvoice, category: 'Invoices' },
  { id: Permission.UpdateInvoice, category: 'Invoices' },
  { id: Permission.DeleteInvoice, category: 'Invoices' },
  { id: Permission.CancelInvoice, category: 'Invoices' },
  { id: Permission.CreateCreditMemo, category: 'Invoices' },
  { id: Permission.PostponeDueDate, category: 'Invoices' },
  { id: Permission.AdjustDueDate, category: 'Invoices' },
  { id: Permission.GoodwillWaive, category: 'Invoices' },
  { id: Permission.CreditLoss, category: 'Invoices' },
  { id: Permission.DcStop, category: 'Invoices' },
  { id: Permission.ReminderStop, category: 'Invoices' },
  { id: Permission.ReplaceInvoice, category: 'Invoices' },
  { id: Permission.ResendInvoice, category: 'Invoices' },
  { id: Permission.ResetStage, category: 'Invoices' },

  // Payments
  { id: Permission.ReadPayment, category: 'Payments' },
  { id: Permission.MatchPayment, category: 'Payments' },
  { id: Permission.DirectPayment, category: 'Payments' },
  { id: Permission.BackdatePayment, category: 'Payments' },
  { id: Permission.ReversePaymentAllocation, category: 'Payments' },
  { id: Permission.CreatePayment, category: 'Payments' },
  { id: Permission.UpdatePayment, category: 'Payments' },

  // Reports
  { id: Permission.CreateReport, category: 'Reports' },
  { id: Permission.ReadReport, category: 'Reports' },
  { id: Permission.DownloadReport, category: 'Reports' },
  { id: Permission.DeleteReport, category: 'Reports' },

  // Dashboards
  { id: Permission.ReadDashboard, category: 'Dashboards' },
  {
    id: Permission.ReadClientPerformanceDashboard,
    category: 'Dashboards',
  },

  // Payouts
  { id: Permission.ReadPayout, category: 'Payouts' },
  { id: Permission.CreatePayout, category: 'Payouts' },
  { id: Permission.UpdatePayout, category: 'Payouts' },

  // Communication
  { id: Permission.ReadEmail, category: 'Communication' },
  { id: Permission.ArchiveEmail, category: 'Communication' },
  { id: Permission.DeleteEmail, category: 'Communication' },

  // Ingestion
  { id: Permission.ReadIngestion, category: 'Ingestion' },
  { id: Permission.WriteIngestion, category: 'Ingestion' },

  // Webhooks
  { id: Permission.CreateWebhooks, category: 'Webhooks' },
  { id: Permission.UpdateWebhooks, category: 'Webhooks' },
  { id: Permission.ReadWebhooks, category: 'Webhooks' },
  {
    id: Permission.ReadWebhooksHistory,
    category: 'Webhooks',
  },
  { id: Permission.RetryWebhook, category: 'Webhooks' },
  { id: Permission.DeleteWebhook, category: 'Webhooks' },
  { id: Permission.DeleteWebhookHistory, category: 'Webhooks' },

  // Settings
  { id: Permission.ReadSettings, category: 'Settings' },
  { id: Permission.ReadOidcClient, category: 'Settings' },
  { id: Permission.ResetOidcSecret, category: 'Settings' },
];

export const ROLE_PRESETS = [
  {
    id: 'client-operator',
    permissions: rolePermissions['client-operator'],
  },
  {
    id: 'key-account-manager',
    permissions: rolePermissions['key-account-manager'],
  },
  {
    id: 'client-manager',
    permissions: rolePermissions['client-manager'],
  },
  {
    id: 'customer-operator',
    permissions: rolePermissions['customer-operator'],
  },
  {
    id: 'custom',
    permissions: [],
  },
];
